module.exports = __webpack_public_path__ + "img/phone.6a1a6dc4.svg";